import { Component, Input, OnInit } from '@angular/core';

import { Storycard, STORYCARD_VARIANTS } from '@finder/shared/components/storycard/storycard.interface';
import { ModalService } from '@finder/shared/components/modal/modal.service';
import { ReadMoreModalComponent } from '@finder/shared/components/read-more-modal/read-more-modal.component';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { PictureComponent } from '../picture/picture.component';
import { ButtonComponent } from '../button/button.component';
import { ScrollToDirective } from '@finder/shared/directives/scroll-to/scroll-to.directive';
import { GetStorycardIdPipe } from '@finder/shared/utils/pipes/get-storycard-id/get-storycard-id.pipe';
import { LocaleDirective } from '@finder/shared/directives/locale/locale.directive';
import { LinkIdDirective } from '@finder/shared/directives/link-id/link-id.directive';
import { RouterLinkDirective } from '@finder/shared/directives/router-link/router-link.directive';

@Component({
    selector: 'finder-storycard',
    templateUrl: './storycard.component.html',
    styleUrls: ['./storycard.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        SafeHtmlPipe,
        FontIconComponent,
        PictureComponent,
        ButtonComponent,
        ScrollToDirective, // finderScrollTo
        GetStorycardIdPipe, // getStorycardId,
        LocaleDirective, // finderLocale
        LinkIdDirective, // finderLinkId
        RouterLinkDirective, // finderRouterLink
    ],
})
export class StorycardComponent implements OnInit {
    @Input() public data: Storycard;
    @Input() public variant: STORYCARD_VARIANTS;

    // Here to be able to use on template
    storycardVariants = STORYCARD_VARIANTS;

    private readMoreModal: ModalComponent;

    constructor(
        private modalService: ModalService,
    ) { }

    ngOnInit() {
        // Check for a moreInfo prop before creating the modal
        if (this.data.sections.find(obj => obj['moreInfo'])) {
            this.readMoreModal = this.modalService.create(ReadMoreModalComponent, {
                hideOnClose: true,
                id: 'read-more-modal'
            });
        }
        this.data.sections.forEach((section) => {
            if (section.title && globalThis.DOMParser) {
                const DOMElement = new DOMParser().parseFromString(section.title, 'text/html');
                const title = DOMElement.querySelector('body > *') as HTMLElement;
                if (title) {
                    section.titleElement = title;
                }

                return true;
            }

            return false;
        });
    }

    openModal(storyCard) {
        if (!this.readMoreModal) {
            return;
        }

        // Update the data the modal uses
        this.readMoreModal.setConfig({
            title: storyCard.title,
            data: {
                moreInfo: storyCard.moreInfo
            }
        });

        // Open the modal
        this.readMoreModal.open();
    }
}
